import { useEffect, useState } from 'react';
import { tv } from 'tailwind-variants';
import { useSearchParams } from 'next/navigation';
import { useRouter } from 'next/router';
import { trackEvent } from 'fathom-client';
import useChargebee from 'lib/hooks/useChargebee';

import { Button, Icon, useModal } from '@frontendmentorio/design-system-v2';

import GetProForFree from './GetProForFree';
import Individuals from './Individuals';
import PaymentMethods from './PaymentMethods';
import PPP from './PPP';
import Teams from './Teams';
import UserDiscount from './UserDiscount';

const styles = tv({
  slots: {
    container: ['container-lg', 'flex', 'flex-col', 'gap-8', 'items-center'],
    button: [
      'font-bold',
      'font-secondary',
      'italic',
      'px-4',
      'py-2',
      'text-sm',
      'transition-colors',
      'uppercase',
      'rounded-full',
      'mobile:px-5',
      'mobile:py-3',
      'mobile:text-base',
    ],
  },
  variants: {
    isActive: {
      true: {
        button: ['bg-blue-500', 'text-white'],
      },
    },
  },
});

const { container, button } = styles();

export default function Plans({ className }) {
  const modal = useModal();
  const router = useRouter();
  const searchParams = useSearchParams();
  const withCheckout = !!useChargebee();

  const [type, setType] = useState('individuals');

  const handleClick = () => {
    trackEvent('Get Pro for Free: modal opened');
    modal.open?.();
  };

  useEffect(() => {
    if (!searchParams.get('getProForFree')) return;

    router.replace(`${window.location.origin}/pro#plans`);

    modal.open?.();
  }, [modal]);

  return (
    <div className={container({ className })}>
      <PPP />
      <UserDiscount />

      <div className="flex flex-col gap-6 items-center w-full">
        <div className="bg-white border border-neutral-200 mb-5 p-1 rounded-full">
          <button
            className={button({ isActive: type === 'individuals' })}
            onClick={() => setType('individuals')}
          >
            For individuals
          </button>

          <button
            className={button({ isActive: type === 'teams' })}
            onClick={() => setType('teams')}
          >
            For teams
          </button>
        </div>

        {type === 'individuals' && <Individuals withCheckout={withCheckout} />}
        {type === 'teams' && <Teams />}

        {withCheckout && (
          <>
            <Button
              className="bg-[hsl(227,45%,44%,10%)] border-2 gap-3"
              isGhost
              level="secondary"
              onClick={handleClick}
            >
              <Icon name="badge-dollar" />
              Get Pro for free
              <Icon name="badge-dollar" />
            </Button>
            <GetProForFree modal={modal} />
          </>
        )}

        <PaymentMethods />
      </div>
    </div>
  );
}
